<template>
    <div class="card wallet-dropdown">
        <div v-on:click="copyAddress" class="wallet-dropdown__item">
            <icon-copy v-show="!successVisible" />
            <icon-success v-show="successVisible" />
            {{ $t('tonconnect.copy_address') }}
        </div>
        <router-link v-on:click.native="openAddressPage" v-bind:to="getLink" class="wallet-dropdown__item router-link__no-style">
            <icon-explore />{{ $t('tonconnect.explore_address') }}
        </router-link>
        <div v-on:click="disconnectWallet" class="wallet-dropdown__item">
            <icon-disconnect />{{ $t('tonconnect.disconnect_wallet') }}
        </div>
    </div>
</template>

<script>
import IconCopy from '@img/icons/tonscan/copy-14.svg?vue';
import IconSuccess from '@primer/octicons/build/svg/check-16.svg?vue';
import IconExplore from '@primer/octicons/build/svg/globe-16.svg?vue';
import IconDisconnect from '@primer/octicons/build/svg/sign-out-16.svg?vue';
import { showToast } from '~/toast';
import { Address } from '~/tonweb';

export default {
    data() {
        return {
            successVisible: false,
        };
    },

    computed: {
        address() {
            const raw = this.$tonConnect.wallet.account.address;
            return new Address(raw).toString({
                userFriendly: true,
                bouncable: false,
                testOnly: false,
            });
        },

        getLink() {
            return { name: 'address', params: { address: this.address } };
        },
    },

    methods: {
        async copyAddress() {
            try {
                await navigator.clipboard.writeText(this.address);
            } catch {
                this.copyToClipboardFallback(this.address);
            }
            this.successVisible = true;

            showToast(this.$t('address.info.copy_success'));

            setTimeout(() => {
                this.successVisible = false;
            }, 1800);
        },

        openAddressPage() {
            // Close the dropdown
            this.$emit('open-address-page');
        },

        async disconnectWallet() {
            await this.$tonConnect.disconnect();
            // Close the dropdown
            this.$emit('open-address-page');
        },
    },

    components: {
        IconCopy,
        IconSuccess,
        IconExplore,
        IconDisconnect,
    },
};
</script>

<style scoped lang="scss">
.wallet-dropdown {
    position: absolute;
    top: 45px;
    right: 6px;
    padding: 8px;
    z-index: 10000;

    &__item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 10px 13px 10px 11px;
        border-radius: 8px;
        gap: 10px;
        white-space: nowrap;
        cursor: pointer;
        user-select: none;

        svg {
            width: 16px;
            color: var(--body-muted-text-color);
            fill: var(--body-muted-text-color);
        }

        &:hover {
            background: var(--body-light-muted-color);
        }
    }
}
</style>
